import React from "react";
import { AlertCircle, Bell, CheckCircle2, Users, Calendar, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

const ManagerDigestCard = ({ data, compact }) => {
    const navigate = useNavigate();

    if (!data) return null;

    const alerts = data.proactive_alerts || [];
    const pendingLeaves = data.pending_leave_approvals || 0;
    const pendingCorrections = data.pending_attendance_corrections || 0;

    if (!alerts.length && !pendingLeaves && !pendingCorrections) {
        return null;
    }

    return (
        <div className="mt-3 overflow-hidden rounded-xl border border-amber-500/30 bg-gradient-to-br from-amber-500/5 via-card to-card p-3.5 shadow-sm">
            {/* Title */}
            <div className="mb-2.5 flex items-center justify-between border-b border-border/60 pb-2">
                <div className="flex items-center gap-2">
                    <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-500/10 text-amber-600 dark:text-amber-400">
                        <Bell className="h-4 w-4 animate-bounce" />
                    </div>
                    <div>
                        <h4 className="text-xs font-semibold text-foreground">Manager Quick Digest</h4>
                        <p className="text-[10px] text-muted-foreground">Proactive HR & Team Alerts</p>
                    </div>
                </div>
                <span className="rounded-full bg-amber-500/10 px-2 py-0.5 text-[10px] font-bold text-amber-700 dark:text-amber-300">
                    {alerts.length || (pendingLeaves + pendingCorrections)} Action(s)
                </span>
            </div>

            {/* Alerts List */}
            <div className="space-y-2">
                {alerts.map((alertText, idx) => (
                    <div
                        key={idx}
                        className="flex items-start gap-2 rounded-lg border border-amber-500/20 bg-amber-500/10 px-2.5 py-2 text-xs text-foreground"
                    >
                        <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600 dark:text-amber-400" />
                        <span className="leading-snug">{alertText}</span>
                    </div>
                ))}
            </div>

            {/* Navigation Shortcuts for Managers */}
            <div className="mt-3 flex flex-wrap gap-2 border-t border-border/60 pt-2.5">
                {pendingLeaves > 0 && (
                    <Button
                        size="sm"
                        onClick={() => navigate("/employee/approvalinbox")}
                        className="flex items-center gap-1.5 bg-amber-600 text-white hover:bg-amber-700 text-xs px-2.5 py-1 rounded-lg cursor-pointer"
                    >
                        <Calendar className="h-3.5 w-3.5" />
                        Review Leaves ({pendingLeaves})
                        <ArrowRight className="h-3 w-3" />
                    </Button>
                )}

                {pendingCorrections > 0 && (
                    <Button
                        size="sm"
                        variant="outline"
                        onClick={() => navigate("/attendance/dayattendance")}
                        className="flex items-center gap-1.5 border-amber-500/40 text-amber-700 dark:text-amber-300 hover:bg-amber-500/10 text-xs px-2.5 py-1 rounded-lg cursor-pointer"
                    >
                        <Users className="h-3.5 w-3.5" />
                        Review Attendance ({pendingCorrections})
                        <ArrowRight className="h-3 w-3" />
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ManagerDigestCard;
